import CompetenceTree from "@/components/Shared/CompetenceTree/CompetenceTree";
import {
	useDeleteOrganisationCompetence,
	useOrganisation,
	useUpdateOrganisationCompetences,
} from "@/networking/organisation.hooks";
import { SettingsLeaf } from "./SettingsLeafLayout";

/**
 * "Tjänster och kompetenser" — admin editor for the organisation competence
 * tree. Editable by all org admins; competences are archived (restorable)
 * rather than deleted so existing jobs, prices and labels keep working.
 * Archived competences no consultant holds can be deleted via a hidden
 * Shift-reveal action.
 * Reads the raw organisation tree so archived nodes stay visible/manageable.
 */
const KompetensTreePage = () => {
	const { data: organisation } = useOrganisation();
	const { mutate: updateCompetence, isLoading } = useUpdateOrganisationCompetences();
	const { mutateAsync: deleteCompetence, isLoading: isDeleting } =
		useDeleteOrganisationCompetence();

	return (
		<SettingsLeaf
			title="Tjänster och kompetenser"
			description="Branscher, tjänster och kompetenser som uppdrag och konsulter matchas på. Arkiverade kompetenser döljs för nya uppdrag men befintliga uppdrag påverkas inte."
		>
			{organisation?.competences && (
				<CompetenceTree
					competences={organisation.competences}
					isSaving={isLoading || isDeleting}
					onRename={(key, sv) => updateCompetence({ key, update: { name: { sv } } })}
					onArchive={(key, archived) => updateCompetence({ key, update: { archived } })}
					onAdd={(parentKey, sv) =>
						updateCompetence({ key: parentKey, update: { add: { name: { sv } } } })
					}
					onDelete={deleteCompetence}
				/>
			)}
		</SettingsLeaf>
	);
};

export default KompetensTreePage;
